import { create } from 'zustand'
import { escapeReferenceToken } from '@criteria/json-pointer'

type AuthorizationStore = Record<string, any>

export const useAuthorizationStore = create<AuthorizationStore>((set) => ({}))

export function useAuthorization(openAPIFileID: string, securitySchemeName: string) {
  const key = `/${openAPIFileID}/${escapeReferenceToken(securitySchemeName)}`
  const value = useAuthorizationStore((store) => store[key])
  return [
    value,
    (newValue: any) =>
      useAuthorizationStore.setState({
        [key]: newValue
      })
  ]
}
